<template>
  <div class="blog-cta">
    <div class="cta-wrapper">
      <div class="cta-content">
        <div class="cta-header">
          <h3>{{ $t("cta.heading") }}</h3>
          <p v-if="false">
            Turn your iPhone or Android into a professional 360° virtual tour
            camera. Create stunning tours in minutes with AI-powered technology.
          </p>
        </div>

        <div class="cta-actions">
          <a
            href="https://play.google.com/store/apps/details?id=com.travvir.studio"
            target="_blank"
            rel="noopener noreferrer"
            class="app-store-btn"
          >
            <NuxtImg
              :src="`${cdnUrl}/static/images/PlayStore.png`"
              :alt="$t('cta.playStoreAlt')"
              loading="lazy"
            />
          </a>
          <a
            href="https://apps.apple.com/in/app/travvir-360-views-from-phone/id6443536819"
            target="_blank"
            rel="noopener noreferrer"
            class="play-store-btn"
          >
            <NuxtImg
              :src="`${cdnUrl}/static/images/AppStore.png`"
              :alt="$t('cta.appStoreAlt')"
              loading="lazy"
            />
          </a>
        </div>
        <!-- <p class="cta-note" v-if="country !== 'IN'">
          {{ $t("cta.pricingNote") }}
          <NuxtLink :to="`${baseURL}/pricing`" external>{{
            $t("cta.pricingLink")
          }}</NuxtLink>
          {{ $t("cta.pricingNoteSuffix") }}
        </p> -->
      </div>
    </div>
  </div>
</template>

<script setup>
const config = useRuntimeConfig();
const cdnUrl = config.public.cdnUrl;
const baseURL = config.public.baseURL;
const country = useState("country");
</script>

<style lang="scss" scoped>
.blog-cta {
  font-family: $theme-font;
  margin: 5rem 0;

  @include respond-below(md) {
    margin: 4rem 0;
  }

  @include respond-below(sm) {
    margin: 3rem 0;
  }

  .cta-wrapper {
    position: relative;
    border-radius: 16px;
    padding: 2px;
    overflow: hidden;

    @include respond-below(sm) {
      border-radius: 12px;
    }

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      opacity: 0;
      transition: opacity 0.3s ease;
    }

    &:hover::before {
      opacity: 1;
    }
  }

  .cta-content {
    background: #0d0d0d;
    border-radius: 14px;
    padding: 3rem;
    text-align: center;
    position: relative;
    z-index: 1;

    @include respond-below(md) {
      padding: 2.5rem 2rem;
    }

    @include respond-below(sm) {
      padding: 2rem 1.5rem;
      border-radius: 10px;
    }
  }

  .cta-header {
    max-width: 600px;
    margin: 0 auto 2.5rem;

    @include respond-below(sm) {
      margin-bottom: 2rem;
    }

    .icon-badge {
      width: 56px;
      height: 56px;
      margin: 0 auto 1.5rem;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;

      @include respond-below(sm) {
        width: 48px;
        height: 48px;
        margin-bottom: 1.25rem;

        svg {
          width: 20px;
          height: 20px;
        }
      }
    }

    h3 {
      font-size: 2rem;
      font-weight: 600;
      line-height: 1.3;
      color: rgba(255, 255, 255, 0.95);
      margin-bottom: 1rem;

      @include respond-below(md) {
        font-size: 1.75rem;
      }

      @include respond-below(sm) {
        font-size: 1.5rem;
        margin-bottom: 0.875rem;
      }
    }

    p {
      font-size: 1.0625rem;
      line-height: 1.6;
      color: rgba(255, 255, 255, 0.65);

      @include respond-below(sm) {
        font-size: 0.9375rem;
      }
    }
  }

  .cta-features {
    display: flex;
    justify-content: center;
    gap: 2rem;
    margin-bottom: 2.5rem;
    flex-wrap: wrap;

    @include respond-below(md) {
      gap: 1.5rem;
    }

    @include respond-below(sm) {
      gap: 1rem;
      margin-bottom: 2rem;
    }

    .feature-item {
      display: flex;
      align-items: center;
      gap: 0.625rem;
      font-size: 0.9375rem;
      color: rgba(255, 255, 255, 0.75);
      font-weight: 500;

      @include respond-below(sm) {
        font-size: 0.875rem;
      }

      .feature-icon {
        width: 24px;
        height: 24px;
        background: rgba(95, 135, 237, 0.15);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #5f87ed;
        flex-shrink: 0;

        @include respond-below(sm) {
          width: 20px;
          height: 20px;

          svg {
            width: 14px;
            height: 14px;
          }
        }
      }
    }
  }

  .cta-actions {
    display: flex;
    gap: 1rem;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    @include respond-below(sm) {
      flex-direction: row;
      gap: 1rem;
      margin-bottom: 1.25rem;
    }

    .app-store-btn,
    .play-store-btn {
      display: inline-flex;
      align-items: center;
      gap: 0.75rem;
      // padding: 0.75rem 1.5rem;
      border-radius: 10px;
      text-decoration: none;
      transition: all 0.3s ease;
      cursor: pointer;
      min-width: 160px;

      @include respond-below(sm) {
        width: 100%;
        justify-content: center;
        // padding: 0.875rem 1.5rem;
      }
      img {
        width: 120px;
        height: auto;

        @include respond-below(sm) {
          width: 40%;
        }
      }
    }

    .app-store-btn {
      background: transparent;
      color: #fff;
      border: 2px solid transparent;
      &:hover {
        transform: translateY(-2px);
      }
    }

    .play-store-btn {
      background: transparent;
      color: #fff;
      border: 2px solid transparent;

      &:hover {
        transform: translateY(-2px);
      }
    }
  }

  .cta-note {
    font-size: 1rem;
    color: rgba(255, 255, 255, 0.4);
    margin-top: 2rem;
    font-weight: 400;
    a {
      text-decoration: underline;
      text-underline-offset: 3px;
    }

    @include respond-below(sm) {
      font-size: 0.75rem;
    }
  }
}
</style>
